<template>
    <div class="items-list-body bf br-m"
        :style="maxItems ? { 'max-height': (maxItems * 5) + 'rem', 'overflow-y': items.length > maxItems ? 'auto' : 'hidden' } : {}">
        <div v-for="(item, ix) in items"
            :key="ix"
            class="items-list-row"
            :class="ix % 2 === 0 ? 'row-even' : 'row-odd'">
            {{ item }}
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'mead-items-list',
    props: {
        /**
         * The list of items to render, one row per entry. Each item is rendered
         * directly as text content within its row.
         */
        items: { type: Array, default: () => [] },
        /**
         * Maximum number of item rows visible before the list becomes vertically
         * scrollable (height is capped at `maxItems * 5rem`). A value of `0`
         * disables the cap, letting the list grow to fit all items.
         */
        maxItems: { type: Number, default: 0 },
    },
};
</script>

<style scoped lang="scss">
@use '../../../sass/variables' as *;

.items-list-body {
    overflow-y: auto;
}

.items-list-row {
    height: 5rem;
    display: flex;
    align-items: center;
    padding: 0 $s-m;
    font-size: $fs-m;

    &.row-even {
        background-color: var(--c-panel-bg);
    }

    &.row-odd {
        background-color: var(--c-panel-dark-bg);
    }
}
</style>
